module.exports = __webpack_public_path__ + "static/media/appIcon.723fd50d.svg";